import { createSlice } from "@reduxjs/toolkit";

const inputDialogBox = createSlice({
    name: 'openDialogBox',
    initialState: { dialogIsVisible: false },
    reducers: {
        openDialogBox(state, action){
            state.dialogIsVisible = action.payload.dialogIsVisible;
        },
    }
});

export const inputDialogBoxActions = inputDialogBox.actions;

export default inputDialogBox;